import { gql } from "__generated__";

export const RemoveOrgMember_Mutation = gql(`
  mutation RemoveOrgMember_Mutation($id: ObjectID!) {
    removeOrgMember(id: $id)
  }
`);
